<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :title="$t('questionnaires.new_question')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="dlg-fields">
            <kimsa-text-field :label="$t('common.name')" :value="name" @change="name = $event" force-value dense />
            <kimsa-text-field :label="$t('common.reference')" :value="reference" @change="reference = $event"
                force-value dense />
            <kimsa-segmented :items="types" item-text="name" item-value="value" :value="type" @change="type = $event" />
            <div v-if="type === 'scale'" class="cq-scale">
                <kimsa-text-field v-for="(option, i) in options" :key="i" :value="options[i].text"
                    @change="options[i].text = $event" force-value dense />
            </div>
        </div>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.save')" :disabled="disabled" :loading="loading"
                @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaSegmented from "@/components/common/inputs/KimsaSegmented";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

import { db } from "@/utils/Firebase";

export default {
    name: "CreateQuestionDialog",
    components: { KimsaTextField, KimsaSegmented, BaseDialog, DialogActions },
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        coachId: {
            type: String,
            default: null,
        },
    },
    data(vm) {
        return {
            dialog: false,
            loading: false,
            name: '',
            reference: '',
            types: [
                { name: vm.$t('questionnaires.short_answer'), value: 'short' },
                { name: vm.$t('questionnaires.scale_answer'), value: 'scale' }
            ],
            type: 'short',
            options: [
                { text: '5', value: 5 },
                { text: '4', value: 4 },
                { text: '3', value: 3 },
                { text: '2', value: 2 },
                { text: '1', value: 1 }
            ],
        }
    },
    computed: {
        disabled(vm = this) {
            return !vm.name || !vm.reference || (vm.type === 'scale' && vm.options.some(option => !option.text))
        }
    },
    methods: {
        show(team) {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.name = ''
            vm.reference = ''
            vm.type = 'short'
            vm.options = [
                { text: '5', value: 5 },
                { text: '4', value: 4 },
                { text: '3', value: 3 },
                { text: '2', value: 2 },
                { text: '1', value: 1 }
            ]
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                let payload = {
                    title: vm.name,
                    type: vm.type,
                    value: 'custom',
                    reference: vm.reference,
                    coachId: vm.coachId,
                }

                if (vm.type === 'scale') payload.options = vm.options

                let newQuestion = await db.collection('questions').add(payload)
                vm.toast(vm.$t('questionnaires.question_created'))

                vm.hide()
                vm.$emit('save', { ...payload, id: newQuestion.id, added: false })
            })
        },
    },

}
</script>

<style scoped>
.dlg-fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.cq-scale {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
</style>